import React, { useState } from 'react';
import TripsTable from '../../components/TripsTable';
import useTrips from '../../hooks/useTrips';
import RouteVehicles from './RouteVehicles';
import Template from '../../components/Template';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


export default function Trips({idPlate,plate, onBack, titleTranslate}) {
    const [selectedTrip, setSelectedTrip] = useState(null);
    const { trips, loading} = useTrips(idPlate);

    const handleBackFromRoute = () => {
        setSelectedTrip(null);
    };

    if (selectedTrip) {
        return (
            <RouteVehicles
                route={selectedTrip.route}
                tripId={selectedTrip.flespi_trip_id}
                plate={plate}
                onBack={handleBackFromRoute}
                titleTranslate={titleTranslate}
            />
        );
    }

    return (
         <Template type={4} classNameContainer="maintenance" className="container_menu maintenance driver">
            <div className="content_dynamic company-block mt-5">
                <Row>
                    <Col>
                        <button
                            onClick={onBack}
                            className="btn-secondary-dark register"
                            style={{ marginBottom: '15px' }}
                        >
                            ← {titleTranslate('vehiclesTrips.back')}
                        </button>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2 className="trips-title">{titleTranslate('vehiclesTrips.trips_for_vehicles')} <strong>{plate}</strong></h2>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <TripsTable trips={trips} loading={loading} onSelect={setSelectedTrip} titleTranslate={titleTranslate} />
                    </Col>
                </Row>
            </div>
        </Template>
    );
}